<template>
  <svg viewBox="0 0 64 64">
    <svg>
      <svg id="meerwaarde">
        <path
          d="M32.1,2.7C15.7,2.7,2.3,15.8,2.3,32s13.4,29.3,29.8,29.3S61.9,48.2,61.9,32S48.5,2.7,32.1,2.7 M32.1,63
                        C14.7,63,0.6,49.1,0.6,32c0-17.1,14.1-31,31.5-31s31.5,13.9,31.5,31C63.6,49.1,49.5,63,32.1,63"
        />
        <path
          d="M32.1,53.3c-11.9,0-21.6-9.6-21.6-21.3c0-0.5,0.4-0.8,0.9-0.8s0.9,0.4,0.9,0.8c0,10.8,8.9,19.6,19.9,19.6
                        S52,42.8,52,32c0-0.5,0.4-0.8,0.9-0.8s0.8,0.4,0.8,0.8C53.7,43.8,44,53.3,32.1,53.3"
        />
        <path
          d="M21.2,18.8c-1.3,0-2.4,1.1-2.4,2.4c0,1.3,1.1,2.4,2.4,2.4s2.4-1.1,2.4-2.4C23.6,19.9,22.5,18.8,21.2,18.8
                         M21.2,25.3c-2.3,0-4.1-1.8-4.1-4.1c0-2.2,1.9-4.1,4.1-4.1s4.1,1.8,4.1,4.1C25.3,23.5,23.4,25.3,21.2,25.3"
        />
        <path
          d="M43,18.8c-1.3,0-2.4,1.1-2.4,2.4c0,1.3,1.1,2.4,2.4,2.4c1.3,0,2.4-1.1,2.4-2.4C45.5,19.9,44.4,18.8,43,18.8
                         M43,25.3c-2.3,0-4.1-1.8-4.1-4.1c0-2.2,1.9-4.1,4.1-4.1c2.3,0,4.1,1.8,4.1,4.1C47.2,23.5,45.3,25.3,43,25.3"
        />
      </svg>
    </svg>
  </svg>
</template>

<script lang="ts">
import { Component, Vue } from 'vue-property-decorator';

@Component
export default class IconMeerwaarde extends Vue {}
</script>
